/**
 * Formato do arquivo do mapa societário gerado no fechamento.
 * É um contrato externo: os nomes dos campos seguem o arquivo de origem.
 */
export type MapNodeType = 'fundo' | 'subclasse' | 'spe' | 'ativo' | 'divida' | 'cotistas';
export type MapEdgeType = 'participacao' | 'composicao' | 'cotistas' | 'divida';

export interface MapNode {
  id: string;
  /** nome */
  t: string;
  curto?: string;
  /** subtítulo */
  s?: string;
  /** valor exibido */
  v?: string;
  tipo: MapNodeType;
  nivel?: number;
  /** patrimônio líquido */
  pl?: number;
  adm?: string;
  fonte?: string;
  cat?: string;
  notas?: number[];
  ficha?: [string, string][];
  itens?: [string, string, number][];
}
export interface MapEdge {
  de: string;
  para: string;
  tipo: MapEdgeType;
  valor?: number;
  pct?: string;
  pctInv?: string;
  instr?: string;
  qtd?: string;
  nota?: number;
}
export interface MapData {
  dataBase?: string;
  nos: MapNode[];
  arestas: MapEdge[];
  /** [número, título, texto] */
  notas?: [number, string, string][];
  /** [id, nome] */
  categorias?: [string, string][];
  linhasExposicao?: string[];
}
export interface OrgMapDocument {
  data: MapData;
  fileName: string;
  importedAt: string;
  importedById: string | null;
}

export const NODE_TYPE_NAME: Record<MapNodeType, string> = { fundo: 'Fundo', subclasse: 'Subclasse', spe: 'Sociedade investida', ativo: 'Ativo', divida: 'Dívida', cotistas: 'Cotistas' };
export const ENTITY_GROUPS: [MapNodeType, string][] = [['fundo', 'Fundos'], ['subclasse', 'Subclasses'], ['spe', 'Sociedades'], ['ativo', 'Ativos'], ['divida', 'Dívidas']];
export const CATEGORY_COLORS: Record<string, string> = { spe: '#1F1F1F', imovel: '#3D8B5F', credito: '#C29A1E', receb: '#2F6F8F', liquidez: '#9A9A9A', divida: '#D0312D', outros: '#CFCFCF' };
export const ADMIN_COLORS = ['#1F1F1F', '#2F6F8F', '#7C5AA6', '#3D8B5F', '#8A5A12', '#B84A3A'];
export const EDGE_TYPE_NAME: Record<MapEdgeType, string> = { participacao: 'Participação', composicao: 'Subclasse compõe o fundo', cotistas: 'Cotistas', divida: 'Dívida (financiamento)' };

/** Entidades que podem ser ligadas a tarefas. */
export const isSelectable = (n: MapNode | undefined): n is MapNode => !!n && n.tipo !== 'cotistas';
export const isFundLike = (n: MapNode | undefined) => !!n && (n.tipo === 'fundo' || n.tipo === 'subclasse');
export const shortName = (n: MapNode) => n.curto || String(n.t).replace(/^CIX /, '').replace(/ (FII RL|FII|FIP)$/, '');
export const entityLabel = (n: MapNode) => n.curto || n.t;
